import SVG from "../SVG";

export const Pointer = () => {
  return (
    <SVG
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="#0A0908"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16 0H0V16L16 0Z" />
    </SVG>
  );
};
